import JSZip from 'jszip';
import { generateCardAsBlob } from './cardGenerator';

/**
 * توليد جميع بطاقات المدرسة وتنزيلها في ملف ZIP
 * @param {Array} users - قائمة المستخدمين
 * @param {string} schoolName - اسم المدرسة
 * @param {string} expiryDate - تاريخ انتهاء الصلاحية (اختياري)
 * @param {Function} onProgress - دالة لتحديث التقدم (اختياري)
 */
export const generateAllSchoolCards = async (
  users,
  schoolName,
  expiryDate = null,
  onProgress = null
) => {
  if (!users || users.length === 0) {
    throw new Error('لا يوجد مستخدمون لتوليد بطاقاتهم');
  }

  const zip = new JSZip();
  const cardsFolder = zip.folder('cards');
  const errors = [];
  let successCount = 0;

  for (let i = 0; i < users.length; i++) {
    const user = users[i];
    
    try {
      // إعداد بيانات المستخدم
      const userName = user.userName || user.fullName || user.name || 'اسم المستخدم';
      const userIdNumber = user.userIdNumber || `USER_${i + 1}`;
      const userImage = user.userImage || user.profileImage || user.image || null;
      const userGender = user.userGender !== undefined ? user.userGender : null;

      const userData = {
        userName,
        schoolName: schoolName || 'اسم المدرسة',
        userIdNumber,
        userImage,
        userGender,
        expiryDate,
      };

      // توليد البطاقة
      const cardBlob = await generateCardAsBlob(userData);
      
      // إضافة البطاقة إلى ZIP
      const fileName = `${userIdNumber}-${userName.replace(/\s+/g, '-')}.png`;
      cardsFolder.file(fileName, cardBlob);
      
      successCount++;

      // تحديث التقدم
      if (typeof onProgress === 'function') {
        onProgress({
          current: i + 1,
          total: users.length,
          percentage: Math.round(((i + 1) / users.length) * 100),
          currentUser: userName,
        });
      }
    } catch (error) {
      console.error(`خطأ في توليد بطاقة ${user.userName || user.userIdNumber}:`, error);
      errors.push({
        user: user.userName || user.userIdNumber,
        error: error.message,
      });
    }
  }

  if (successCount === 0) {
    throw new Error('فشل توليد جميع البطاقات');
  }

  // إنشاء ملف نصي بالأخطاء إذا وجدت
  if (errors.length > 0) {
    let errorText = 'الأخطاء التي حدثت أثناء توليد البطاقات:\n\n';
    errors.forEach((err, index) => {
      errorText += `${index + 1}. المستخدم: ${err.user}\n   الخطأ: ${err.error}\n\n`;
    });
    cardsFolder.file('errors.txt', errorText);
  }

  // توليد ملف ZIP
  const zipBlob = await zip.generateAsync({ 
    type: 'blob',
    compression: 'DEFLATE',
    compressionOptions: {
      level: 6
    }
  });

  // تنزيل الملف
  const schoolNameClean = schoolName.replace(/[^a-zA-Z0-9\u0600-\u06FF\s-]/g, '').replace(/\s+/g, '-');
  const timestamp = new Date().toISOString().slice(0, 10);
  const fileName = `cards-${schoolNameClean}-${timestamp}.zip`;

  const link = document.createElement('a');
  link.href = URL.createObjectURL(zipBlob);
  link.download = fileName;
  link.click();

  // تنظيف
  setTimeout(() => URL.revokeObjectURL(link.href), 100);

  return {
    success: successCount,
    errors: errors.length,
    total: users.length,
  };
};

